import * as actionTypes from "../actions/actionTypes.js";

const initialState = {
    menuList:[]

};



export default function pharmacy(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case actionTypes.GET_MENUS_ITEM_SECCUSS :
            return Object.assign({}, state, {menuList: action.payload});
        default:
            return state;
    }
}
